import React, {Fragment} from "react";


export default class StepInformation extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.timeout = null;

        this.state = {
            showTooltip: false
        }
    }

    showTooltip() {
        if (this.timeout !== null)
            clearTimeout(this.timeout);
        this.setState({showTooltip: true});
    }

    hideTooltip() {
        if (this.timeout !== null)
            clearTimeout(this.timeout);

        this.timeout = setTimeout(() => {
            this.timeout = null;
            this.setState({
                showTooltip: false
            });
        }, 250);
    }

    render() {
        if (this.props.children === undefined) {
            return <Fragment/>
        }
        return <Fragment>
            <i className={"fa fa-info-circle step_information"}
               // onMouseEnter={this.showTooltip.bind(this)}
               // onMouseLeave={this.hideTooltip.bind(this)}
               onClick={() => {
                   this.setState({showTooltip: !this.state.showTooltip});
               }}
            />
            {this.state.showTooltip && this.renderTooltip()}
        </Fragment>
    }

    renderTooltip() {
        return <Fragment>
            <div className={"step_information_tooltip"}
                 // onMouseEnter={this.showTooltip.bind(this)}
                 // onMouseLeave={this.hideTooltip.bind(this)}
                 onClick={() => {
                     this.setState({showTooltip: !this.state.showTooltip});
                 }}
            >
                {this.props.children}
            </div>
            <div className={"step_information_sheet"}
                 onClick={() => {
                     this.setState({showTooltip: false})
                 }}
            >&nbsp;</div>
        </Fragment>
    }
}